import { loadScript, ClientAnalytics } from "@shopify/hydrogen";
import { useEffect } from "react";
import { googleTagManager } from "../../settings/_googleConfig";

const GTAG_ID = googleTagManager.gtag_id;
const URL = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
let init = false;

export default function SetupGoogleAnalytics() {
    useEffect(() => {
        if (googleTagManager.enable && !init) {
            init = true;

            // Load the gtag script
            loadScript(URL).catch(() => { });

            function trackPageView(payload: any) {
                gtag('event', 'page_view');
            }

            // gtag initialization code
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());

            // Configure your gtag
            gtag('config', GTAG_ID, {
                send_page_view: false,
            });

            ClientAnalytics.subscribe(
                ClientAnalytics.eventNames.PAGE_VIEW,
                trackPageView
            );

            ClientAnalytics.hasSentFirstPageView() &&
                trackPageView(ClientAnalytics.getPageAnalyticsData());
        }
    });



    useEffect(() => {
        const handleClick = (e) => {
          if (e.target.closest('[href*="tel:"]')) {
            gtag('event', 'conversion', {
              'send_to': 'AW-11371779490/x3qiCIqM1fAYEKKrvq4q'
            });
          }
        };
    
        document.addEventListener('click', handleClick, {
          capture: true
        });
    
        return () => {
          document.removeEventListener('click', handleClick, {
            capture: true
          });
        };
      }, []);



      let timer; 
      useEffect(() => {
        if (window.location.pathname === '/page/contact') {
          let x = 0;
          timer = setInterval(() => {
            const greenTextElements = document.querySelectorAll('.text-green-500');
            if (greenTextElements.length > 0 && greenTextElements[0].innerText.includes('sent')) {
              if (x === 0) {
                gtag('event', 'conversion', {
                  'send_to': 'AW-11371779490/tcXNCJXPofAYEKKrvq4q'
                });
                x = 1;
              }
              clearInterval(timer);
            }
          }, 1000);
        }
    
        return () => {
          if (timer) {
            clearInterval(timer);
          }
        };
      }, []);

    return null;
} 